"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

export const PersonalizationContainerComponent: RegisteredComponent = {
  name: "Personalization Container",
  component: dynamic(() => import("./PersonalizationContainer").then((mod) => mod.PersonalizationContainer)),
  canHaveChildren: true,
  inputs: [
    {
      name: "renderFullViewportLoader",
      type: "boolean",
      defaultValue: false,
      helperText: "Reserve space while personalization data is loading. Enable only for large blocks like Hero.",
    },
  ],
};
